import { Navigate } from 'react-router-dom'
import { Spin } from 'antd'
import { useAuth } from '../context/AuthContext'

function Guard({ loading, user, allow, children }) {
  if (loading) return <Spin size="large" style={{ display: 'block', margin: '120px auto' }} />
  if (!user) return <Navigate to="/login" replace />
  if (!allow) return <Navigate to="/dashboard" replace />
  return children
}

export function StoreManageRoute({ children }) {
  const { user, canManageStore, loading } = useAuth()
  return <Guard loading={loading} user={user} allow={canManageStore}>{children}</Guard>
}

export function SuperAdminRoute({ children }) {
  const { user, canManageGlobally, loading } = useAuth()
  return <Guard loading={loading} user={user} allow={canManageGlobally}>{children}</Guard>
}

export default StoreManageRoute
